import { Component, OnInit } from '@angular/core';

import { PopoverController } from '@ionic/angular';

import { UtilsService } from '@shared/providers/utils.service';
import { PopoverLanguagesComponent } from './popover-languages/popover-languages.component';

@Component({
  selector: 'app-button-language',
  templateUrl: './button-language-select.component.html',
  styleUrls: ['./button-language-select.component.scss'],
})
export class ButtonLanguageSelect implements OnInit {
  public languageFlagUrl: string;
  public languageLabel: string;
  constructor(
    private utils: UtilsService,
    private popoverController: PopoverController
  ){}

  ngOnInit() {
    const languageData = this.utils.getCurrentLanguage();
    this.languageLabel = languageData.languageLabel;
    this.languageFlagUrl = languageData.languageFlagUrl;
  }

  async openLanguagesPopover(event: any) {
    const popover = await this.popoverController.create({
      component: PopoverLanguagesComponent,
      event,
      translucent: true,
    });

    await popover.present();
    const { data } = await popover.onWillDismiss();

    // Check if language has changed
    if (data && data.languageSelected.languageLabel !== this.languageLabel) {
      localStorage.setItem('languageData', JSON.stringify(data.languageSelected));
      window.location.reload();
    }
  }
}
